import { render, staticRenderFns } from "./StudentProgramme.vue?vue&type=template&id=69ec137b&"
import script from "./StudentProgramme.vue?vue&type=script&lang=js&"
export * from "./StudentProgramme.vue?vue&type=script&lang=js&"
import style0 from "./StudentProgramme.vue?vue&type=style&index=0&id=69ec137b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports